import { ArrowRight, Users, TrendingUp } from "lucide-react";

// Talent Engine Section
export const TalentTeaser = () => (
  <section className="py-24 lg:py-32 bg-[#1C1C1C]">
    <div className="max-w-6xl mx-auto px-6 lg:px-12">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Content */}
        <div className="text-center lg:text-left">
          <div className="text-sm font-mono text-[#D4AF37] tracking-widest uppercase mb-4">Talent Engine</div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight leading-tight mb-5">
            Your Next Top AEs Are Already on Your <span className="text-[#D4AF37]">SDR Team.</span>
          </h2>
          <p className="text-lg text-zinc-300 leading-relaxed mb-4">
            Most companies try to hire great AEs. I build them internally from SDR.
          </p>
          <p className="text-zinc-300 leading-relaxed mb-6">
            SDR isn't a temporary role—it's the foundation of a stronger revenue organization. Companies that develop talent internally build more consistent pipeline, reduce hiring risk, and create long-term revenue leverage.
          </p>
          
          {/* Proof Point */}
          <div className="inline-flex items-center gap-4 px-5 py-3 bg-[#0A0A0A] rounded-xl border border-[#D4AF37]/20 mb-8">
            <div className="text-3xl font-semibold text-[#D4AF37]">65%+</div>
            <div className="text-sm text-zinc-300 text-left">
              of new revenue was closed by AEs<br />I developed internally from SDRs
            </div>
          </div>
          
          <div className="block">
            <a 
              href="/resources/talent-pool"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-[#0A0A0A] rounded-md font-semibold hover:bg-[#E8C547] transition-all"
            >
              Read the Talent Guide
              <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
        
        {/* Visual - SDR to AE Pipeline */}
        <div className="flex justify-center lg:justify-end">
          <div className="relative bg-[#0A0A0A] rounded-2xl p-8 border border-white/5">
            <div className="text-xs font-mono text-zinc-400 uppercase tracking-wider mb-6 text-center">SDR → AE Pipeline</div>
            
            {/* Flow Visual */}
            <div className="flex items-center justify-center gap-6">
              <div className="w-28 h-28 rounded-xl bg-[#1C1C1C] border border-white/10 flex flex-col items-center justify-center">
                <Users className="w-10 h-10 text-zinc-400 mb-2" />
                <span className="text-sm text-zinc-300 font-medium">SDR</span>
              </div>
              
              <div className="flex flex-col items-center">
                <ArrowRight className="w-8 h-8 text-[#D4AF37]" />
                <span className="text-xs text-[#D4AF37] mt-2 font-medium">18 months</span>
              </div>
              
              <div className="w-28 h-28 rounded-xl bg-[#D4AF37]/20 border-2 border-[#D4AF37]/40 flex flex-col items-center justify-center">
                <TrendingUp className="w-10 h-10 text-[#D4AF37] mb-2" />
                <span className="text-sm text-[#D4AF37] font-medium">AE</span>
              </div>
            </div>
            
            {/* Stats row */}
            <div className="grid grid-cols-2 gap-4 mt-8 pt-6 border-t border-white/5">
              <div className="text-center">
                <div className="text-xl font-semibold text-white">2x</div>
                <div className="text-xs text-zinc-400">ROI vs external hire</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-semibold text-white">Lower</div>
                <div className="text-xs text-zinc-400">Hiring risk</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TalentTeaser;
